import { Link } from 'react-router-dom'

/** Shown when the API refuses a write because billing is inactive or over limit. */
export function SubscriptionPaywall({
  orgId,
  code,
  message,
}: {
  orgId: string
  code: 'subscription_required' | 'plan_limit_exceeded'
  message?: string
}) {
  const title =
    code === 'plan_limit_exceeded'
      ? 'Plan limit reached'
      : 'Subscription required'
  const body =
    message ??
    (code === 'plan_limit_exceeded'
      ? 'This organization has reached a limit on its current plan.'
      : 'An active subscription is required before you can send documents.')

  return (
    <div className="card notice notice-bad paywall">
      <h2>{title}</h2>
      <p className="muted">{body}</p>
      <Link className="btn" to={`/orgs/${orgId}/billing`}>
        View billing
      </Link>
    </div>
  )
}
